var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "container",
      class: _vm.isReady ? "page-show" : "page-hide",
    },
    [
      _c("div", { staticClass: "detail-header" }, [
        _c("h3", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.baseInfo.gonggaoTitle)),
        ]),
        _c("div", { staticClass: "detail-info flex" }, [
          _c("div", { staticClass: "detail-info-item" }, [
            _c("span", [_vm._v("报名截止")]),
            _c("span", { staticClass: "mt-20" }, [
              _vm._v(_vm._s(_vm._f("formatterDateTime")(_vm.baseInfo.endTime))),
            ]),
          ]),
          _c("div", { staticClass: "detail-info-item" }, [
            _c("span", [_vm._v("预算金额")]),
            _c("span", { staticClass: "mt-20 color-theme-red" }, [
              _vm._v(_vm._s(_vm.baseInfo.budgetMoneyFormat)),
            ]),
          ]),
          _c("div", { staticClass: "detail-info-item" }, [
            _c("span", [_vm._v("项目状态")]),
            _c(
              "span",
              {
                staticClass: "mt-20",
                class: _vm.baseInfo.signUpUrl ? "color-theme-red" : "color-999",
              },
              [_vm._v(_vm._s(_vm.baseInfo.statusName))]
            ),
          ]),
          _c(
            "div",
            { staticClass: "detail-info-item" },
            [
              _c("span", [_vm._v("操作")]),
              _c(
                "el-button",
                {
                  staticClass: "application-btn",
                  attrs: { type: "primary", disabled: !_vm.baseInfo.signUpUrl },
                  on: { click: _vm.openLogin },
                },
                [_vm._v(_vm._s(_vm.baseInfo.btnName))]
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm.sectionList.length > 1 && !_vm.sectionId
        ? _c("detail-list", { attrs: { list: _vm.sectionList } })
        : _vm.baseInfo.infoid
        ? _c("detail-info", {
            attrs: { "base-info": _vm.baseInfo, "section-id": _vm.sectionId },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }